<template>
  <div>
    <v-card id="card" :class="['card-text', 'rounded-0']" color="" style="">
      <v-row :class="[row_classes(), 'px-1']">
        <v-col class="my-auto py-0" @click="clickItem">
          <v-row>
            <v-col cols="8">
              <v-row>
                <v-col cols="6" class="">
                  {{$t("periodOrMonth")}}:{{ item.PeriodName }}
                </v-col>
                <v-col cols="6" class="">{{ getStatus(item.status) }} </v-col>
              </v-row>
            </v-col>

            <v-col
              cols="4"
              style="
                justify-content: left;
                align-content: center;
                display: flex;
              "
            >
            </v-col>
          </v-row>
        </v-col>
        <v-col class="my-auto py-0" cols="auto">
          <v-btn icon @click="show = !show" class="card-text">
            <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-expand-transition class="">
        <div v-show="show" class="mt-1">
          <v-row @click="clickItem">
            <v-col>
              <v-row>
                <v-col cols="6" class="my-auto"
                  >{{ $t("RequestDate") }} :
                  <span class="text-value">{{ item.RECDATE }}</span>
                </v-col>
                <v-col cols="6" class="my-auto"
                  >{{ $t("specificExtraWork") }} :
                  <span class="text-value">{{ item.ExtraWork }}</span>
                </v-col>
                
              </v-row>
            </v-col>
            <v-col cols="auto py-0">
              <div style="width: 36px; height: 36px"></div>
            </v-col>
          </v-row>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
import StatusType from "@/model/StatusType";
export default {
  props: {
    item: Object,
  },
  computed: {},
  data() {
    return {
      show: false,
    };
  },
  methods: {
    clickItem() {
      this.$emit("onClickItem", this.item);
    },
    getStatus(status) {
      return StatusType.getStatus(status);
    },
    row_classes() {
      if (this.item.isGroup == 1) {
        return "bg-green"; //can also return multiple classes e.g ["orange","disabled"]
      }
    },
  },
};
</script>

<style scoped>
* {
  padding: 0px;
  margin: 0px;
}

.card-text {
  font-size: 0.875rem !important;
  color: var(--black) !important;
}

.text-caption-color {
  color: #8b8b8b;
}

.state .v-icon {
  font-size: 1rem;
}
</style>